<template>
    <div class="d-flex flex-column ga-4 w-100">
        <v-card
            v-for="(act, idx) in acts"
            :key="act.id ?? idx"
            class="mb-3"
            outlined
            elevation="3"
        >
            <v-toolbar>
                <v-toolbar-title class="d-flex align-center ga-2">
                    <strong>{{ idx + 1 }}. Act Adițional</strong>

                    <!-- chip appears only while act.is_sent === false -->
                    <v-chip
                        v-if="statusLabel(act)"
                        :color="statusColor(act)"
                        text-color="white"
                        size="small"
                        class="ml-3"
                    >
                        {{ statusLabel(act) }}
                        <v-tooltip
                            v-if="act.is_refused && act.refused_reason"
                            size="small"
                            color="danger"
                            location="top"
                            activator="parent"
                            :title="act.refused_reason"
                        >
                            Motiv refuz: {{ act.refused_reason }}
                        </v-tooltip>
                    </v-chip>
                </v-toolbar-title>
                <v-toolbar-items>
                    <v-btn
                        color="success"
                        size="small"
                        :loading="act.loadingGenerate"
                        :disabled="!act.id"
                        @click="triggerGenerateAct(act)"
                    >
                        Vizualizează
                    </v-btn>
                    <v-btn
                        color="primary"
                        size="small"
                        :loading="act.loadingSend"
                        :disabled="!act.id || act.is_signed || act.is_refused"
                        @click="triggerSendAct(act)"
                    >
                        Trimite
                    </v-btn>
                    <v-btn
                        color="error"
                        size="small"
                        outlined
                        :disabled="act.is_signed"
                        @click="$emit('delete-act', act)"
                    >
                        Șterge
                    </v-btn>
                </v-toolbar-items>
            </v-toolbar>
            <v-card-text>
                <v-row class="d-flex justify-space-between mb-4">
                    <v-col>
                        <div v-if="act.date">Date: {{ act.date }}</div>
                        <div v-if="act.status">Status: {{ act.status }}</div>

                        <h4
                            v-if="
                                act.autoDiffs &&
                                Object.keys(act.autoDiffs).length
                            "
                        >
                            Schimbări generate automat:
                        </h4>
                        <ul
                            v-if="
                                act.autoDiffs &&
                                Object.keys(act.autoDiffs).length
                            "
                        >
                            <li
                                v-for="(change, field) in act.autoDiffs || {}"
                                :key="field"
                            >
                                <strong>{{ field }}</strong
                                >: {{ change.old }} → {{ change.new }}
                            </li>
                        </ul>

                        <h6>Modificări manuale:</h6>
                        <div
                            v-for="(mod, mIdx) in act.modifications || []"
                            :key="mIdx"
                            class="d-flex align-center mb-2"
                        >
                            <v-text-field
                                v-model="act.modifications[mIdx]"
                                placeholder="Descrie modificarea…"
                                dense
                                variant="outlined"
                                hide-details
                                class="flex-grow-1"
                                @blur="$emit('update-act-mods', act)"
                            />
                            <v-btn
                                icon
                                variant="plain"
                                small
                                @click="removeModification(act, mIdx)"
                            >
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </div>
                        <v-btn text small @click="addModification(act)">
                            + Adaugă modificare
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { showAlertModal } from "@/utils/utils";

export default {
    name: "AdditionalActsManager",
    props: {
        acts: {
            type: Array,
            default: () => [],
        },
    },
    methods: {
        statusLabel(act) {
            if (!act.id) return "Nesalvat"; // never hit backend
            if (act.is_refused) return "Refuzat"; // refused by client
            if (!act.is_sent) return "Netrimis"; // saved, not emailed
            if (!act.is_signed) return "Nesemnat"; // emailed, not signed
            return "Semnat"; // signed
        },
        statusColor(act) {
            const map = {
                Nesalvat: "grey",
                Netrimis: "red-darken-2",
                Nesemnat: "orange-darken-2",
                Refuzat: "pink-darken-2",
                Semnat: "green-darken-2",
            };
            return map[this.statusLabel(act)];
        },
        triggerGenerateAct(act) {
            if (act.id) this.$emit("generate-act", act);
            else
                showAlertModal(
                    this.$store,
                    "Actul adițional poate fi vizualizat doar dacă este salvat! Vă rugăm salvați modificările!",
                    "danger",
                    12000
                );
        },
        triggerSendAct(act) {
            if (act.id) this.$emit("send-act", act);
            else
                showAlertModal(
                    this.$store,
                    "Actul adițional poate fi trimis doar dacă este salvat! Vă rugăm salvați modificările!",
                    "danger",
                    12000
                );
        },
        addModification(act) {
            act.modifications.push("");
            this.$emit("update-act-mods", act);
        },
        removeModification(act, idx) {
            act.modifications.splice(idx, 1);
            // Optionally immediately emit update to parent:
            this.$emit("update-act-mods", act);
        },
    },
};
</script>
